import { Grid, TextField, Typography, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import i18n from 'i18n';
import React from 'react';
import styles from '../styles';

const useStyles = makeStyles(styles);

export interface Props {
  onClose: () => void;
  onConfirm: (message: string) => void;
}

const IgnoreMessage = ({ onClose, onConfirm }: Props) => {
  const [message, setMessage] = React.useState('');
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={2}
      className={classes.container}
      data-testid={'autosky-ignoremessage'}
    >
      <Grid container direction="column">
        <Grid item>
          <Typography>
            {i18n.t('ADVISOR_PAGE.CONFIRM_IGNORE_ADVISOR_KEY')}
          </Typography>
        </Grid>

        <Grid item className={classes.form}>
          <TextField
            label={i18n.t('MESSAGE_KEY')}
            onChange={e => setMessage(e.target.value)}
            multiline
            rows={3}
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container justify="flex-end" className={classes.buttonsBase}>
        <Grid container className={classes.buttonsAlign}>
          <Button
            id="submit-button"
            onClick={() => onConfirm(message)}
            disabled={!message.trim()}
            submitButton
          >
            {i18n.t('CONFIRM_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={onClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IgnoreMessage;
